import Grid from '@mui/material/Unstable_Grid2/Grid2'
import OneModal from "../../../../../Components/OneModal/OneModal"
import { Tooltip, Typography } from '@mui/material'
import OneButton from '../../../../../Components/OneButton/OneButton'
import OneTextArea from '../../../../../Components/OneTextArea/OneTextArea'
import { useContext, useState } from 'react'
import { showNotify } from '../../../../../Utils/Utils'
import { VisitantesContext } from '../../../../../Providers/VisitantesContext/VisitantesContext'

const ObsLibTempModal = ({ openObsLibTemp, setOpenObsLibTemp, tempoLiberacao }) => {
    const { liberarAcessoTemp } = useContext(VisitantesContext)
    const [obs, setObs] = useState('')
    const [qntCaracteres, setQntCaracteres] = useState(0)

    return (
        <OneModal
            open={openObsLibTemp}
            setOpen={setOpenObsLibTemp}
            titleText="Liberar acesso temporário"
            fullWidth={true}
            FooterButtons={() =>
                <Tooltip title={qntCaracteres < 5 ? "Mínimo de 5 caracteres!" : "Liberar temporariamente visitantes selecionados!"}>
                    <div>
                        <OneButton
                            backgroundColor="#0FBB00"
                            variant="contained"
                            disabled={qntCaracteres < 5}
                            onClick={() => {
                                liberarAcessoTemp(tempoLiberacao, obs)
                                setOpenObsLibTemp(false)
                            }}
                        >
                            Confirmar liberação temporária
                        </OneButton>
                    </div>
                </Tooltip>}
        >
            <Grid xs={12} gap={1} sx={{
                display: 'flex',
                flexFlow: 'column',
                height: '100%',
                width: '100%',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
                <Grid container xs={12} sx={{
                    display: 'flex',
                    width: '100%',
                    height: 'fit-content',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <Grid xs={6} sx={{
                        padding: 0,
                        margin: 0
                    }}>
                        <Typography component="div" sx={{
                            padding: 0,
                            margin: 0,
                            fontWeight: 600
                        }}>
                    Observações:
                        </Typography>
                    </Grid>
                    <Grid xs={6} sx={{
                        padding: 0,
                        margin: 0,
                        display: 'flex',
                        justifyContent: 'flex-end'
                    }}>
                        <Typography color={'red'} component="div" sx={{
                            padding: 0,
                            margin: 0
                        }}>
                    Mín. de 5 caracteres
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container xs={12} gap={1} sx={{
                    display: 'flex',
                    width: '100%',
                    height: 'fit-content',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <OneTextArea
                        newSx={{
                            height: '100px'
                        }}
                        onChange={(e) => {
                            if (e.target.value.length > 255) {
                                showNotify('warning', 'Máximo de 255 caracteres')
                            } else {
                                setObs(e.target.value)
                                setQntCaracteres(e.target.value.length)
                            }
                        }}
                        value={obs}
                    />
                    <Typography color={qntCaracteres < 5 ? 'red' : 'black'} component="div" sx={{
                        padding: 0,
                        margin: 0,
                        display: 'flex',
                        justifyContent: 'flex-start',
                        width: '100%'
                    }}>
                        {255 - qntCaracteres}/255 Caracteres restantes
                    </Typography>
                </Grid>
            </Grid>
        </OneModal>
    )
}

export default ObsLibTempModal
